import React from "react";
import Control from "./Control";

const SimpleDynamicList = ({
  listLabel,
  uniqueKey,
  element,
  fields,
  items,
  btnLabel,
  change,
  disabled,
  // Message d'erreur de la liste entière (ex. : l'API désigne l'adresse fautive), affiché sous la liste.
  error = null,
}) => {
  function addItem() {
    items.push("");
    change({ target: { name: element, value: items } });
  }

  function changeItem(e, k) {
    items[k] = e.target.value;
    change({ target: { name: element, value: items } });
  }
  function removeItem(kk) {
    items = items.filter((i, k) => k !== kk);
    change({ target: { name: element, value: items } });
  }

  return (
    <div className="form-group">
      <label>{listLabel}</label>
      <ul className="list-group list-unstyled" aria-invalid={error ? true : undefined}>
        {items.map((it, k) => (
          <li key={"dyn" + element + uniqueKey + "_" + k}>
            <div className="form-inline">
              {fields.map((fi, kk) => (
                <Control
                  className="mr-2"
                  k={k}
                  key={"dynlistinp" + kk}
                  label={fi.label}
                  name={fi.name}
                  type={fi.type}
                  value={it}
                  datas={fi.datas}
                  change={changeItem}
                  suffix={fi.suffix ? fi.suffix : null}
                  margin={fi.margin ? fi.margin : ""}
                  disabled={fi.disabled}
                />
              ))}
              {!disabled && (
                <button
                  className="btn btn-default btn-sm"
                  onClick={() => removeItem(k)}
                >
                  <i className="fa fa-times text-danger" />
                </button>
              )}
            </div>
          </li>
        ))}
      </ul>
      {error && (
        <small role="alert" className="form-text text-danger">
          {error}
        </small>
      )}
      {btnLabel && !disabled && (
        <button className="btn btn-default btn-sm mt-2" onClick={addItem}>
          <i className="fa fa-plus mr-2" />
          {btnLabel}
        </button>
      )}
    </div>
  );
};

export default SimpleDynamicList;
